import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export type StatusMessageType = 'empty' | 'error' | 'interrupted';

interface StatusMessageProps {
  type: StatusMessageType;
  title: string;
  description?: string;
  onAction?: () => void;
  actionLabel?: string;
  icon: ReactNode;
  iconBgClassName: string;
}

export function StatusMessage({
  type,
  title,
  description,
  onAction,
  actionLabel,
  icon,
  iconBgClassName,
}: StatusMessageProps) {
  const hasAction = type !== 'empty';

  return (
    <div className="my-16">
      <div
        className={cn(
          'mx-auto flex h-20 w-20 items-center justify-center rounded-full',
          iconBgClassName
        )}
      >
        {icon}
      </div>
      <div className="mt-4 space-y-1">
        <p className="text-event text-center font-medium">{title}</p>
        <p className="text-chat-subtext text-center text-sm">
          <span>{description}</span>
        </p>
      </div>
      {hasAction && onAction && (
        <div className="mt-4 flex justify-center">
          <Button variant="outline" size="sm" onClick={onAction}>
            <span>{actionLabel}</span>
          </Button>
        </div>
      )}
    </div>
  );
}
